<div class="chart">
    <canvas *ngIf="pieChartData?.length != 0" height="300" [labels]="pieChartLabels" [legend]="pieChartLegend" baseChart
        [data]="pieChartData" [chartType]="pieChartType"></canvas>
</div>